import React from 'react'
import ReactDOM from 'react-dom'
import './css/index.css'
import axios from 'axios'
import App from './App'
import reportWebVitals from './reportWebVitals'

import * as serviceWorkerRegistration from './serviceWorkerRegistration'

// Capture PWA install prompt globally so components like ProfilePopover can trigger it
if (typeof window !== 'undefined') {
    window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault()
        window.deferredPWAInstallPrompt = e
        window.dispatchEvent(new CustomEvent('pwa-prompt-available'))
    })

    window.addEventListener('appinstalled', () => {
        window.deferredPWAInstallPrompt = null
        window.isPWAInstalled = true
        window.dispatchEvent(new CustomEvent('pwa-installed'))
    })
}

axios.defaults.withCredentials = true

ReactDOM.render(<App />, document.getElementById('root'))

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

serviceWorkerRegistration.register()
